export function toggleOne(selected: Set<number>, id: number) {
  const next = new Set(selected);
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return next;
}

export function selectRange(
  selected: Set<number>,
  visibleIds: number[],
  fromId: number,
  toId: number,
) {
  const fromIndex = visibleIds.indexOf(fromId);
  const toIndex = visibleIds.indexOf(toId);
  if (fromIndex === -1 || toIndex === -1) return toggleOne(selected, toId);

  const [start, end] =
    fromIndex < toIndex ? [fromIndex, toIndex] : [toIndex, fromIndex];
  const next = new Set(selected);
  for (const id of visibleIds.slice(start, end + 1)) next.add(id);
  return next;
}
